/* global __DEV__ */
/* eslint no-console: 0 */

import window from "global/window";

const PLACEHOLDER_USER_ID = '-99';
const PLACEHOLDER_ORG_ID = '-999';

function trackEvent(event_name, payload, schema) {
  payload.event_name = event_name;

  if (window.datacoral) {
    var datacoralPayload = Object.assign(payload, {
      user_id: window.TRACKER_USER_ID || PLACEHOLDER_USER_ID,
      org_id: window.TRACKER_ORG_ID|| PLACEHOLDER_ORG_ID
    });

    log("datacoral trackUnstructEvent called with:", {data: datacoralPayload});
    window.datacoral("trackUnstructEvent", {data: datacoralPayload});
  } else {
    log("datacoral JS tracking not enabled");
  }

  if (window.snowplow) {
    // NOTE: Contexts are added with addGlobalContexts
    var snowplowEvent = {
      event: {
        schema: schema || 'iglu:io.greenhouse/generic-event/jsonschema/1-0-0',
        data: payload,
      }
    };

    log("snowplow trackSelfDescribingEvent called with:", snowplowEvent);

    window.snowplow('trackSelfDescribingEvent', snowplowEvent);
  } else {
    log("snowplow JS tracking is not enabled");
  }
}

function log() {
  if (__DEV__) {
    console.log.apply(void 0, arguments);
  }
}

export { trackEvent };
